import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import Renderer from './Renderer';
import { Translate, I18n } from 'react-redux-i18n';

// import SUSJSApp from 'susjs-renderer';

import { selectPreviewLocation as selectPreviewLocationAction } from './DashboardActions';


function Preview(props) {
  const dispatch = useDispatch();

  const {
      exercise,
      selectedUnits,
      selectedLocation,
      selectedPreviewLocation
  } = useSelector(state => ({
      exercise: state.exercise.exercise,
      selectedUnits: state.dashboard.selectedUnits,
      selectedLocation: state.dashboard.selectedLocation,
      selectedPreviewLocation: state.dashboard.selectedPreviewLocation,
  }));

  const [scenarioBlob, setScenarioBlob] = useState(null);
  const [scenarioUrl, setScenarioUrl] = useState("");
  const [assets, setAssets] = useState([]);
  const [selectedAssetIndex, setSelectedAssetIndex] = useState(-1);
  const [draggingAsset, setDraggingAsset] = useState(false);
  const [addedAssets, setAddedAssets] = useState([]);
  const [selectedAddedAssetIndex, setSelectedAddedAssetIndex] = useState(-1);

  useEffect(() => {
    downloadScenario();
    // componentwillunmount logic was empty/commented out
  }, []);

  function downloadScenario() {
    const { scenario } = exercise;

    let headers = {
      Accept: 'application/zip, application/octet-stream, application/x-zip-compressed, multipart/x-zip',
    };

    if (scenario.url.indexOf('/api') === 0 || scenario.url.startsWith("/")) {
      headers.Authorization = localStorage.token;
    }
    
    let scenarioUniqueId;
    if(scenario.url.startsWith("/")) {
      const aPath = scenario.url.split("/archive.zip")[0];
      const split = aPath.split("/");
      scenarioUniqueId = split[split.length - 1];
    }
    
    /* fetch(scenario.url.startsWith("/")? `/api/scenarios/${exercise.companyId}/${scenarioUniqueId}/archive` : scenario.url, {
      method: 'GET',
      headers
    })
      .then(response => {
        return response.blob();

      })
      .then(file => {
        setScenarioBlob(file);
      }); */

    setScenarioUrl(scenario.url.startsWith("/")? `/api/scenarios/${exercise.companyId}/${scenarioUniqueId}/archive` : scenario.url);
  }

  function changePreviewLocation(event) {
    dispatch(selectPreviewLocationAction(event.target.value));
  }

  function changePreviewLocationFromRenderer(loc) {
    dispatch(selectPreviewLocationAction(loc.id));
  }
  
  function handleAddAsset() {
    // Legacy code commented out in original file, keeping only the action
    document.getElementById("add-asset-input").click();
  }
  
  function handleScaleAsset(e) {
    e.persist();
    const newValue = e.target.value;
    const newWidth = newValue + "%";
    
    const updatedList = addedAssets.map((asset, index) => {
        if(index === selectedAddedAssetIndex) {
          return { ...asset, width: newWidth };
        }
        return asset;
    });

    setAddedAssets(updatedList);
    _updateAsset(updatedList[selectedAddedAssetIndex]);
  }
  
  function _sendAsset(asset) {
    const reader = new FileReader();
    reader.readAsDataURL(asset.file);
    
    reader.onload = readerEvent => {
      const content = readerEvent.target.result;
      global.socket.emit('asset_added', { target: '', message: { ...asset, file: content} });
    }
  }
  
  function _updateAsset(data) {
    global.socket.emit('asset_updated', { target: '', message: {...data, file: undefined} })
  }

    const { users, scenario } = exercise;


    const locations = scenario && scenario.locations;

    let renderName = I18n.t('preview.previewTitle');
    let setLocation = '';

    if (selectedLocation !== '') {
      let selLocation = locations.find(loc => loc.id === selectedLocation);
      if (selLocation) {
        renderName = I18n.t('preview.previewForTitle') + ' ' +
          selLocation.name + ' ' + I18n.t('preview.previewLocation');

        setLocation = selectedLocation;
      }
    }
    else if (selectedUnits.length === 1) {
      let selectedUser = users.find(user => user.id === selectedUnits[0]);

      if (selectedUser) {
        let selLocation = locations.find(loc => loc.id === selectedUser.location);
        renderName = I18n.t('preview.followingTitle', {name: selectedUser.name, location: selLocation.name});

        setLocation = selectedUser ? selectedUser.location : selectedPreviewLocation;
      }
      else {
        let selLocation = locations.find(loc => loc.id === selectedPreviewLocation);
        renderName = I18n.t('preview.followingTitle', {name: 'nobody', location: selLocation.name});

        setLocation = selectedPreviewLocation;
      }
    }

    const locationsOptionsList = scenario.locations.filter(loc => loc.name.indexOf('__') !== 0).map((loc, i) => <option key={i} value={loc.id}>{loc.name} {loc.state ? `[${loc.state}]`: ''}</option>);


    return (
      <div>

          <div className="simPlaces">
            <div className="preview__fixed">
              <Renderer isNavEnabled={false} isInteractive={false} isPaused={ !exercise.playStartedAt } location={setLocation} hideUI scenarioUrl={scenarioUrl} /* scenarioBlob={scenarioBlob} *//>
            </div>
          <div>
            <div className="preview__header">
              <strong>{renderName}</strong>
            </div>
            <Renderer isNavEnabled={false} isInteractive={false} isPaused={ !exercise.playStartedAt } location={setLocation} hideUI scenarioUrl={scenarioUrl} /* scenarioBlob={scenarioBlob} *//>
          </div>
          <div>
            <div className="preview__header">
              <strong><Translate value="preview.interactiveView"/></strong>
              &nbsp;
              <select value={selectedPreviewLocation} onChange={changePreviewLocation}>
                { locationsOptionsList }
              </select>
              <button onClick={handleAddAsset} style={{margin: '0px 15px'}}>Add Asset</button>
              <input id="add-asset-input" type="file" multiple 
                accept=".png,.jpg,.jpeg"
                style={{display: 'none'}} 
                onChange={(e) => {
                  e.persist();
                  const files = [...e.target.files];
                  setAssets(prev => prev.concat(files));
                  const fileEl = document.getElementById("add-asset-input");
                  fileEl.value = fileEl.defaultValue;
                }}
              />
              <select onChange={(e) => setSelectedAssetIndex(e.target.value)} style={{width: 100}}>
                <option value={-1}>No Asset Selected</option>
                {
                  assets.map((asset, index) => {
                    return (
                      <option value={index} key={index}>{ asset.name } {/*<button onClick={() => this.setState((prevState) => ({ selectedAssetIndex: -1, assets: prevState.assets.filter((_, i) => i !== index)}) )}>x</button>*/}</option>
                    )
                  })
                }
              </select>
              {
                selectedAssetIndex !== -1 &&
                <img
                  src={URL.createObjectURL(assets[selectedAssetIndex])}
                  style={{ height: 50 }}
                  draggable
                  onDragStart={() => {
                    console.log("Started dragging:", assets[selectedAssetIndex])
                    setDraggingAsset(true);
                  }}
                  onDragEnd={() => {
                    console.log("Asset drag ended");
                  }}
                />
              }
              {
                selectedAddedAssetIndex !== -1 &&
                <input type="number" value={addedAssets[selectedAddedAssetIndex].width.replace("%", "")} min="1" max="100" onChange={handleScaleAsset} />
              }
            </div>
            <div id="private-view" style={{position: 'relative'}}>
              <div style={{width: '100%', height: '100%'}}>
                <div 
                  id="on-renderer"
                  style={{ position: 'absolute', zIndex: 100, width: '100%', height: '100%', }}
                  onDragEnter={(e) => {console.log("Drag Enter", e)}}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.persist();
                    console.log("Dragging asset?", draggingAsset, e);
                    const el= document.getElementById("private-view");
                    const rect = el.getBoundingClientRect();
                    console.log(el.offsetWidth, e.clientX, el.offsetHeight, e.clientY, "Bounding Rect:", rect);
                    if(draggingAsset) {
                      const newAsset = {
                          id: Math.ceil(Math.random() * 1000),
                          file: assets[selectedAssetIndex],
                          x: ((e.clientX - rect.x) /* + (img.width / 2) */)  / el.offsetWidth * 100,
                          y: ((e.clientY - rect.y) /* + (img.height / 2) */)  / el.offsetHeight * 100,
                          location: selectedPreviewLocation,
                          width: "15%",
                      };
                      
                      setAddedAssets(prev => prev.concat(newAsset));
                      setDraggingAsset(false);

                      setTimeout(() => {
                        _sendAsset(newAsset)
                      }, 100)

                    } else {
                      const locationRelativeIndex = parseInt(e.dataTransfer.getData("locationRelativeIndex"));
                      console.log("locationRelativeIndex:", locationRelativeIndex, "with type:", typeof locationRelativeIndex)
                      
                      const newAssets = addedAssets.map((asset, index) => {
                          if(index === locationRelativeIndex) {
                              return {
                                  ...asset,
                                  x: ((e.clientX - rect.x) /* + (img.width / 2) */)  / el.offsetWidth * 100,
                                  y: ((e.clientY - rect.y) /* + (img.height / 2)*/)  / el.offsetHeight * 100
                              };
                          }
                          return asset;
                      });

                      setAddedAssets(newAssets);
                      
                      setTimeout(() => {
                        _updateAsset(newAssets[locationRelativeIndex])  
                      }, 100)
                    }
                  }}
                >
                  <div style={{position: 'relative', width: '100%', height: '100%',}}>
                    {
                      addedAssets.map((asset, index) => {
                        if(asset.location !== selectedPreviewLocation) return null;
                        return (
                          <img
                            key={index}
                            src={URL.createObjectURL(asset.file)}
                            style={{
                              position: 'absolute',
                              top: `${asset.y}%`,
                              left: `${asset.x}%`,
                              // height: 50,
                              width: asset.width,
                              border: selectedAddedAssetIndex === index? '1px solid yellow' : 'none',
                            }}
                            draggable
                            onDragStart={(e) => e.dataTransfer.setData("locationRelativeIndex", index)}
                            onClick={() => setSelectedAddedAssetIndex(prev => prev === index ? -1 : index)}
                          />
                        )
                      })
                    }
                  </div>
                </div>
              </div>
              <Renderer isNavEnabled={true} isPaused={ !exercise.playStartedAt } onLocationChange={changePreviewLocationFromRenderer} location={selectedPreviewLocation} hideUI scenarioUrl={scenarioUrl} /* scenarioBlob={scenarioBlob} *//>
            </div>
          </div>
        </div>
      </div>
    );
}

Preview.propTypes = {
  // exercise: PropTypes.object,
  // selectedUnits: PropTypes.array,
  // selectedLocation: PropTypes.string,
};

export default Preview;
